// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "firstLoginAgreement__root-28dTI";
var _4 = "root-1rLv7";
var _5 = "title-3buCu";
var _6 = "icon_wrapper-1FNNB";
var _7 = "message-iMVM3";
var _8 = "row-2Nzsz";
var _9 = "input_wrapper-2eIOS";
var _a = "label-3o4o3";
var _b = "error-1Gtlm";
var _c = "checkbox_wrapper-3vyEC";
var _d = "checkbox-22EZL";
var _e = "checked-2rbrx";
var _f = "button_wrapper-2XGBI";
export { _1 as "__esModule", _2 as "mobile", _3 as "firstLoginAgreement__root", _4 as "root", _5 as "title", _6 as "icon_wrapper", _7 as "message", _8 as "row", _9 as "input_wrapper", _a as "label", _b as "error", _c as "checkbox_wrapper", _d as "checkbox", _e as "checked", _f as "button_wrapper" }
export default { "__esModule": _1, "mobile": _2, "firstLoginAgreement__root": _3, "root": _4, "title": _5, "icon_wrapper": _6, "message": _7, "row": _8, "input_wrapper": _9, "label": _a, "error": _b, "checkbox_wrapper": _c, "checkbox": _d, "checked": _e, "button_wrapper": _f }
